import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Clock, ArrowLeft } from 'lucide-react';
import { useStore } from '../lib/store';
export function Services() {
  const navigate = useNavigate();
  const {
    services
  } = useStore();
  return <div className="px-6 pt-6 pb-6 space-y-6" data-id="element-1043">
      <header className="flex items-center gap-4 mb-2" data-id="element-1044">
        <button onClick={() => navigate(-1)} className="text-light hover:text-gold" data-id="element-1045">
          <ArrowLeft size={24} data-id="element-1046" />
        </button>
        <h2 className="text-2xl font-semibold text-light" data-id="element-1047">Servicios</h2>
      </header>
      <p className="text-xs text-light-muted -mt-4" data-id="element-1048">
        Precios en pesos uruguayos (UYU)
      </p>
      <div className="space-y-4" data-id="element-1049">
        {services.map(s => <div key={s.id} className="bg-dark-card rounded-2xl p-5 border border-white/5" data-id="element-1050">
            <div className="flex justify-between items-start gap-3 mb-2" data-id="element-1051">
              <h3 className="text-lg font-medium text-light" data-id="element-1052">{s.name}</h3>
              <span className="text-lg font-semibold text-gold whitespace-nowrap" data-id="element-1053">
                ${s.price.toLocaleString('es-UY')}
              </span>
            </div>
            <p className="text-sm text-light-muted mb-4" data-id="element-1054">{s.desc}</p>
            <div className="flex justify-between items-center" data-id="element-1055">
              <span className="text-xs text-light-muted flex items-center gap-1" data-id="element-1056">
                <Clock size={14} data-id="element-1057" /> {s.duration}
              </span>
              <Link to="/reservar" className="text-xs bg-white/5 text-light px-4 py-2 rounded-lg font-medium hover:bg-white/10 transition-colors" data-id="element-1058">
                Reservar
              </Link>
            </div>
          </div>)}
      </div>
    </div>;
}